import styled from 'styled-components';

interface DesktopInfoMessageContainerProps {
  backgroundColor: string;
}

export const ColCustomIcon = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 5px;
  cursor: pointer;
  box-shadow: none;
`;

export const DesktopInfoMessageContainer = styled.div<DesktopInfoMessageContainerProps>`
  width: 383px;
  padding: 5px 10px;
  gap: 10px;
  border-radius: 8px;
  background-color: ${(props) => props.backgroundColor};
  text-align: center;
  margin-bottom: 10px;
`;

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
`;

export const DiffItemContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
`;

export const DiffItemBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1px;
  flex: 1 0 0;
  align-self: stretch;
`;

export const DiffItemNameWrapper = styled.div`
  display: flex;
  width: 258px;
  align-items: flex-start;
  gap: 4px;
`;

export const CloseIconContainer = styled.div`
  height: 24px;
  display: flex;
  margin-left: auto;
`;

export const PriceContainer = styled.div`
  display: flex;
  padding: 4px 8px;
  align-items: center;
  gap: 4px;
  border-radius: 36px;
  margin-top: auto;
  background-color: ${({ theme }) => theme.palette.lynxWhite};
`;

export const Separator = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.palette.gray87};
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  height: 40px;
  margin-top: 0px;
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-top: 16px;
  }
`;

export const AddHotelButton = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  padding: 8px 24px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  cursor: pointer;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.NL0};
  border: 1px solid ${({ theme }) => theme.palette.R600};
`;

export const DiffHotelButton = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  padding: 8px 24px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  cursor: pointer;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.R600};
  border: 1px solid ${({ theme }) => theme.palette.R600};
`;

export const MobileBodyContainer = styled.div`
  padding-left: 10px;
  padding-right: 10px;
`;

export const MobileInfoMessageContainer = styled.div<DesktopInfoMessageContainerProps>`
  padding: 5px 10px;
  gap: 10px;
  align-self: stretch;
  background-color: ${(props) => props.backgroundColor};
  text-align: center;
  margin-bottom: 10px;
  border-radius: 8px;
`;

export const MobileDiffItemNameWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 4px;
  width: 100%;
`;

export const MobileDiffItemWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const MobileButtonWrapper = styled.div`
  width: 100%;
  padding: 16px;
  height: 72px;
  box-shadow: 0px -10px 20px 0px rgba(58, 58, 58, 0.1);
  border: 1px solid ${({ theme }) => theme.palette.NL0};
`;

export const NoItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
`;
